import { _ as _define_property } from "@swc/helpers/_/_define_property";
import React from 'react';
import { compose } from 'redux';
import classnames from 'classnames';
import Dropzone from 'react-dropzone';
import { withTranslation } from 'react-i18next';
import withFileUpload from '../../_hocs/withFileUpload';
import { withVerification } from '../../../VerificationPopup/withVerification';
import { MIME_CONFIG, mimeTypesToDropzoneAccept } from '../../../utils/mime';
import uploadDropzoneStyles from './UploadDropzone.scss';
const enhance = compose(withVerification, withFileUpload, withTranslation());
class UploadDropzone extends React.Component {
    componentDidMount() {
        document.addEventListener('dragenter', this.onDragEnterLeave, true);
        document.addEventListener('dragleave', this.onDragEnterLeave, true);
        document.addEventListener('drop', this.onDragEnterLeave, true);
    }
    componentWillUnmount() {
        document.removeEventListener('dragenter', this.onDragEnterLeave, true);
        document.removeEventListener('dragleave', this.onDragEnterLeave, true);
        document.removeEventListener('drop', this.onDragEnterLeave, true);
    }
    render() {
        const { className, t } = this.props;
        return /*#__PURE__*/ React.createElement("div", {
            className: classnames(uploadDropzoneStyles['root'], this.state.dragInProgress && uploadDropzoneStyles['root-active'])
        }, /*#__PURE__*/ React.createElement(Dropzone, {
            noClick: true,
            multiple: true,
            accept: mimeTypesToDropzoneAccept(MIME_CONFIG.forMediaManager),
            onDrop: this.onFileDrop
        }, ({ isDragActive, isDragAccept, isDragReject, getRootProps, getInputProps })=>/*#__PURE__*/ React.createElement("div", getRootProps({
                className: classnames(uploadDropzoneStyles['dropzone'], className, isDragActive && uploadDropzoneStyles['dropzone-active'], isDragAccept && uploadDropzoneStyles['dropzone-accept'], isDragReject && uploadDropzoneStyles['dropzone-reject'])
            }), /*#__PURE__*/ React.createElement("input", getInputProps()), isDragReject && t('mediapopup.upload.dropzone.reject'), isDragActive && !isDragReject && t('mediapopup.upload.dropzone.accept'))));
    }
    constructor(...args){
        super(...args), _define_property(this, "state", {
            dragInProgress: false
        }), _define_property(this, "dragCount", 0), _define_property(this, "onFileDrop", (acceptedFiles, rejectedFiles)=>{
            const { uploadFiles, isVerificationNeeded, pushVerificationPopup } = this.props;
            if (acceptedFiles.length === 0) {
                return;
            }
            if (isVerificationNeeded) {
                pushVerificationPopup('submit');
                return;
            }
            uploadFiles(acceptedFiles.map((file)=>({
                    file
                })));
        }), _define_property(this, "onDragEnterLeave", (e)=>{
            e.preventDefault();
            switch(e.type){
                case 'dragenter':
                    this.dragCount++;
                    break;
                case 'dragleave':
                    this.dragCount--;
                    break;
                case 'drop':
                    this.dragCount = 0;
                    break;
                default:
            }
            this.setState({
                dragInProgress: this.dragCount === 1
            });
        });
    }
}
export default enhance(UploadDropzone);

//# sourceMappingURL=UploadDropzone.js.map